/**
 * Template « Pop » — dégradé, fun, direct. Porté 1:1 depuis le fichier de
 * référence (menu-templates.html, `.pop` + fonction `pop(m)`).
 */
import { forwardRef } from "react";

import type { MenuCardData } from "../types";
import { PortraitPlaceholder } from "./PortraitPlaceholder";

export const PopTemplate = forwardRef<HTMLDivElement, { data: MenuCardData }>(
  function PopTemplate({ data }, ref) {
    return (
      <div
        ref={ref}
        style={{
          boxSizing: "border-box",
          width: "100%",
          aspectRatio: "4 / 5",
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          background: "linear-gradient(150deg, #ff69a8 0%, #c95ad0 48%, #7d54ff 100%)",
          color: "#fff",
          padding: "24px 22px 20px",
          fontFamily: '"Helvetica Neue", Arial, sans-serif',
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div
            style={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              overflow: "hidden",
              flex: "none",
              border: "3px solid rgba(255,255,255,.85)",
            }}
          >
            {data.photoUrl ? (
              <img
                src={data.photoUrl}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            ) : (
              <PortraitPlaceholder bg="#c95ad0" fg="rgba(255,255,255,.7)" />
            )}
          </div>
          <div>
            <h2
              style={{
                fontSize: 34,
                fontWeight: 800,
                letterSpacing: "-0.02em",
                lineHeight: 0.9,
                textShadow: "0 2px 0 rgba(0,0,0,.12)",
                margin: 0,
              }}
            >
              {data.name}
            </h2>
            <p style={{ fontSize: 11, letterSpacing: "0.12em", opacity: 0.9, marginTop: 4 }}>
              Choisis ton plaisir
            </p>
          </div>
        </div>
        <ul
          style={{
            listStyle: "none",
            margin: "16px 0 0",
            padding: 0,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}
        >
          {data.lines.map((line) => (
            <li
              key={line.id}
              style={{
                display: "grid",
                gridTemplateColumns: "auto 1fr auto",
                alignItems: "center",
                gap: 10,
                background: "rgba(255,255,255,.16)",
                border: "1px solid rgba(255,255,255,.22)",
                borderRadius: 11,
                padding: "8px 12px",
              }}
            >
              <span style={{ fontSize: 15 }}>{line.emoji}</span>
              <span style={{ fontSize: 13, fontWeight: 500 }}>{line.label}</span>
              <span
                style={{
                  fontSize: 14,
                  fontWeight: 800,
                  fontVariantNumeric: "tabular-nums",
                  background: "#fff",
                  color: "#b23c86",
                  borderRadius: 8,
                  padding: "2px 8px",
                }}
              >
                {line.price}
              </span>
            </li>
          ))}
        </ul>
        <div style={{ textAlign: "center", fontSize: 11, fontWeight: 500, opacity: 0.92, marginTop: 12 }}>
          Dis-moi ce qui te fait envie 💌
        </div>
      </div>
    );
  },
);
